import { WorkflowWriteBackMode } from 'libs/end-to-end/src/types/databases/workflows/workflow-write-back-mode';
import { z } from 'zod';
import { WriteBackChartHopStrategy } from 'libs/end-to-end/src/types/databases/workflows/promotion-readiness-score-write-back/sources/chart-hop';

export const WorkflowPromotionReadinessScoreWriteBackStrategy =
  WriteBackChartHopStrategy;

export type WorkflowPromotionReadinessScoreWriteBackStrategy = z.infer<
  typeof WorkflowPromotionReadinessScoreWriteBackStrategy
>;

export const WorkflowPromotionReadinessScoreWriteBackDetails = z.object({
  type: z.literal('promotionReadinessScoreWriteBack'),

  /**
   * The strategy for writing back.
   */
  strategy: WorkflowPromotionReadinessScoreWriteBackStrategy.optional(),

  /**
   * The mode for writing back.
   */
  mode: WorkflowWriteBackMode.optional(),

  /**
   * The minimum readiness rating for an employee to be considered for writing back.
   */
  minReadinessRating: z.number().optional(),

  /**
   * The maximum amount of readiness scores to write back. This is used to limit the amount of data
   * that is written back to the target system, mainly for testing purposes.
   */
  numberOfSamplesToSend: z.number().optional(),
});

export type WorkflowPromotionReadinessScoreWriteBackDetails = z.infer<
  typeof WorkflowPromotionReadinessScoreWriteBackDetails
>;
